class NetworkService {
  constructor() {
    this.isOnline = navigator.onLine;
    this.listeners = [];
    this.retryQueue = [];
    
    this.initializeListeners();
  }

  initializeListeners() {
    // Monitor online/offline events
    window.addEventListener('online', () => {
      console.log('🌐 Network: Back online');
      this.isOnline = true;
      this.notifyListeners();
      this.processRetryQueue();
    });

    window.addEventListener('offline', () => {
      console.log('📴 Network: Gone offline');
      this.isOnline = false;
      this.notifyListeners();
    });

    // Monitor connection quality
    if ('connection' in navigator) {
      navigator.connection.addEventListener('change', () => {
        console.log('📡 Connection changed:', {
          effectiveType: navigator.connection.effectiveType,
          downlink: navigator.connection.downlink,
          rtt: navigator.connection.rtt
        });
        this.notifyListeners();
      });
    }
  }

  getConnectionInfo() {
    if ('connection' in navigator) {
      return {
        effectiveType: navigator.connection.effectiveType,
        downlink: navigator.connection.downlink,
        rtt: navigator.connection.rtt,
        saveData: navigator.connection.saveData
      };
    }
    return null;
  }

  isSlowConnection() {
    const info = this.getConnectionInfo();
    return info && (info.effectiveType === 'slow-2g' || info.effectiveType === '2g');
  }

  addListener(callback) {
    this.listeners.push(callback);
  }

  removeListener(callback) {
    this.listeners = this.listeners.filter(listener => listener !== callback);
  }

  notifyListeners() {
    this.listeners.forEach(callback => {
      try {
        callback(this.isOnline, this.getConnectionInfo());
      } catch (error) {
        console.error('Error in network listener:', error);
      }
    });
  }

  addToRetryQueue(operation) {
    this.retryQueue.push(operation);
  }

  async processRetryQueue() {
    if (!this.isOnline || this.retryQueue.length === 0) return;

    console.log(`🔄 Processing ${this.retryQueue.length} queued operations`);
    
    const operations = [...this.retryQueue];
    this.retryQueue = [];

    for (const operation of operations) {
      try {
        await operation();
        console.log('✅ Retry operation successful');
      } catch (error) {
        console.error('❌ Retry operation failed:', error);
        // Re-queue for later retry if it's a network error
        if (this.isNetworkError(error)) {
          this.retryQueue.push(operation);
        }
      }
    }
  }

  isNetworkError(error) {
    return error.message?.includes('network') || 
           error.message?.includes('timeout') ||
           error.message?.includes('fetch') ||
           error.code === 'NETWORK_ERROR';
  }
}

export default new NetworkService(); 